module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/2/3-49962b4d725a4bc35933871c77acc5fb.jpg";